/* section-product.js — product detail page controller */
/* global window, document */

const PDPEl = document.getElementById('pdp-data');
const PDP = PDPEl ? JSON.parse(PDPEl.textContent) : {};

let currentPdpVariantId = PDP.currentVariantId;
let activeSlideIndex = 0;
const totalPdpSlides = PDP.mediaCount;
const videoIndex = PDP.videoIndex;
const hasProductVideo = PDP.hasVideo;
const pdpVariantPrices = PDP.variants;


  function normalizePdpText(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  // 1. Gallery Sliding (1 Image at a Time)
  function slidePdpGallery(direction) {
    const track = document.getElementById('pdp-slider-track');
    if (!track) return;
    
    const slides = track.querySelectorAll('.pdp-slide-item');
    if (!slides.length) return;

    const isMobile = window.innerWidth <= 768;
    const slideWidth = slides[0].offsetWidth + (isMobile ? 0 : 2);
    track.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
  }

  function jumpToPdpSlide(index) {
    const track = document.getElementById('pdp-slider-track');
    if (!track) return;

    const slides = track.querySelectorAll('.pdp-slide-item');
    if (slides[index]) {
      const targetLeft = slides[index].offsetLeft - track.offsetLeft;
      track.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

      const counterEl = document.getElementById('pdp-current-slide-num');
      if (counterEl) {
        counterEl.textContent = Math.min(index + 1, totalPdpSlides);
      }
    }
  }

  function jumpToPdpVideo(videoIdx) {
    const idx = parseInt(videoIdx, 10);
    jumpToPdpSlide(idx);

    // Auto-play the video element
    setTimeout(() => {
      const vidEl = document.getElementById('pdp-product-video');
      if (vidEl) {
        vidEl.play().catch(() => {});
      }
    }, 400);
  }

  // Monitor Slider Scroll Position & Active Slide to auto-hide video badge & update counter
  const __initSectionProduct1 = () => {
    const track = document.getElementById('pdp-slider-track');
    const counterEl = document.getElementById('pdp-current-slide-num');
    const videoPillBadge = document.getElementById('pdp-video-pill-badge');

    if (track) {
      track.addEventListener('scroll', () => {
        const scrollLeft = track.scrollLeft;
        const slides = track.querySelectorAll('.pdp-slide-item');
        if (!slides.length) return;

        const isMobile = window.innerWidth <= 768;
        const slideWidth = slides[0].offsetWidth + (isMobile ? 0 : 2);
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (counterEl) {
          counterEl.textContent = Math.min(newIndex + 1, totalPdpSlides);
        }

        // Hide video badge if currently on video slide, show otherwise
        if (hasProductVideo && videoPillBadge) {
          if (newIndex === videoIndex) {
            videoPillBadge.classList.add('is-hidden');
          } else {
            videoPillBadge.classList.remove('is-hidden');
          }
        }
      }, { passive: true });
    }
  }
  document.addEventListener('DOMContentLoaded', __initSectionProduct1);
  document.addEventListener('shopify:section:load', __initSectionProduct1);
  if (document.readyState !== 'loading') __initSectionProduct1();

  // Switch Gallery Image when a Color is chosen
  function switchGalleryToColor(colorName, variant) {
    const track = document.getElementById('pdp-slider-track');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('.pdp-slide-item'));
    if (!slides.length) return;

    const mediaId = variant ? (variant.media_id || variant.image_id) : null;
    const imgPos = variant ? parseInt(variant.image_position, 10) : null;

    // 1. Try matching media ID or Image ID
    if (mediaId && String(mediaId).trim().length > 0) {
      const idx = slides.findIndex(s => {
        const sMediaId = s.getAttribute('data-media-id');
        const sImageId = s.getAttribute('data-image-id');
        return (sMediaId && sMediaId === String(mediaId)) || (sImageId && sImageId === String(mediaId));
      });
      if (idx !== -1) {
        jumpToPdpSlide(idx);
        return;
      }
    }

    // 2. Try matching image position from variant
    if (imgPos && !isNaN(imgPos) && imgPos > 0) {
      const posIdx = slides.findIndex(s => parseInt(s.getAttribute('data-position'), 10) === imgPos);
      if (posIdx !== -1) {
        jumpToPdpSlide(posIdx);
        return;
      }
      if (slides[imgPos - 1]) {
        jumpToPdpSlide(imgPos - 1);
        return;
      }
    }

    // 3. Try matching color name in alt tag or image filename
    if (colorName) {
      const normColor = normalizePdpText(colorName);
      const cleanColor = colorName.trim().toLowerCase();
      
      const altIdx = slides.findIndex(s => {
        const alt = (s.getAttribute('data-alt') || '').toLowerCase();
        const img = s.querySelector('img');
        const src = img ? (img.src || '').toLowerCase() : '';
        const normAlt = normalizePdpText(alt);
        const normSrc = normalizePdpText(src);

        return normAlt.includes(normColor) || normSrc.includes(normColor) ||
               alt.includes(cleanColor) || src.includes(cleanColor);
      });

      if (altIdx !== -1) {
        jumpToPdpSlide(altIdx);
        return;
      }

      // 4. Color Swatch Index Proportional Mapping
      const chips = Array.from(document.querySelectorAll('.pdp-color-chip'));
      if (chips.length > 1 && slides.length > 1) {
        const chipIndex = chips.findIndex(c => normalizePdpText(c.getAttribute('data-color-name')) === normColor);
        if (chipIndex !== -1) {
          const targetSlideIdx = Math.floor((chipIndex / chips.length) * slides.length);
          if (slides[targetSlideIdx]) {
            jumpToPdpSlide(targetSlideIdx);
            return;
          }
        }
      }
    }
  }

  // Find variant matching active color and/or size
  function findPdpVariant(colorName, sizeName) {
    const normColor = normalizePdpText(colorName);
    const normSize = normalizePdpText(sizeName);

    // 1. Exact match for both color and size
    if (normColor && normSize) {
      for (const id in pdpVariantPrices) {
        const v = pdpVariantPrices[id];
        const vOpts = [v.option1, v.option2, v.option3, v.title].map(normalizePdpText);
        const hasColor = vOpts.some(o => o && (o.includes(normColor) || normColor.includes(o)));
        const hasSize = vOpts.some(o => o && (o.includes(normSize) || normSize.includes(o)));
        if (hasColor && hasSize) return v;
      }
    }

    // 2. Match color only
    if (normColor) {
      for (const id in pdpVariantPrices) {
        const v = pdpVariantPrices[id];
        const vOpts = [v.option1, v.option2, v.option3, v.title].map(normalizePdpText);
        if (vOpts.some(o => o && (o.includes(normColor) || normColor.includes(o)))) {
          return v;
        }
      }
    }

    // 3. Match size only
    if (normSize) {
      for (const id in pdpVariantPrices) {
        const v = pdpVariantPrices[id];
        const vOpts = [v.option1, v.option2, v.option3, v.title].map(normalizePdpText);
        if (vOpts.some(o => o && (o.includes(normSize) || normSize.includes(o)))) {
          return v;
        }
      }
    }

    return null;
  }

  // Instant Clean Price & Variant Update
  function updatePdpPriceAndVariant(variantId) {
    if (!variantId) return;
    const vData = pdpVariantPrices[variantId];
    if (!vData) return;
    currentPdpVariantId = variantId;
    syncPdpVariantInput(variantId);

    // Update Price Display
    const priceContainer = document.querySelector('.pdp-price-container');
    if (priceContainer) {
      if (vData.is_sale && vData.compare_at_price) {
        priceContainer.innerHTML = `
          <span id="pdp-price-display" class="pdp-price-amount pdp-price-sale">${vData.price}</span>
          <span id="pdp-compare-price-display" class="pdp-compare-price-amount">${vData.compare_at_price}</span>
          <span class="pdp-sale-discount-tag">-${vData.discount}% OFF</span>
        `;
      } else {
        priceContainer.innerHTML = `
          <span id="pdp-price-display" class="pdp-price-amount">${vData.price}</span>
        `;
      }
    }

    // Update Button State
    updatePdpButtonState(vData.available, vData.price);
  }

  // 2. Specified Color Selection
  let pdpSelectedColor = PDP.initialColor;
  let pdpSelectedSize = PDP.initialSize;

  function selectPdpColor(button, colorName) {
    document.querySelectorAll('.pdp-color-chip').forEach(b => b.classList.remove('is-selected'));
    if (button) button.classList.add('is-selected');
    pdpSelectedColor = colorName;

    const label = document.getElementById('pdp-selected-color-label');
    if (label) label.textContent = colorName.toUpperCase();

    // Match variant and switch image
    const matchedVariant = findPdpVariant(colorName, pdpSelectedSize);
    if (matchedVariant) {
      updatePdpPriceAndVariant(matchedVariant.id);
      switchGalleryToColor(colorName, matchedVariant);
    } else {
      switchGalleryToColor(colorName, null);
    }
  }

  // 3. Size Selection (Only Clean Size)
  function selectPdpSizeValue(button, sizeName, variantId, formattedPrice, isAvailable) {
    document.querySelectorAll('.pdp-size-pill-box').forEach(b => b.classList.remove('is-selected'));
    if (button) button.classList.add('is-selected');
    pdpSelectedSize = sizeName;

    const cleanSize = sizeName.split('/')[0].trim().toUpperCase();
    const sizeLabel = document.getElementById('pdp-selected-size-label');
    if (sizeLabel) sizeLabel.textContent = cleanSize;

    const matchedVariant = findPdpVariant(pdpSelectedColor, sizeName);
    if (matchedVariant) {
      updatePdpPriceAndVariant(matchedVariant.id);
    } else if (variantId && pdpVariantPrices[variantId]) {
      updatePdpPriceAndVariant(variantId);
    } else {
      if (variantId) currentPdpVariantId = variantId;
      updatePdpButtonState(isAvailable, formattedPrice);
    }
  }

  function updatePdpButtonState(isAvailable, formattedPrice) {
    const ctaBtn = document.getElementById('pdp-add-to-bag-btn');
    const ctaText = ctaBtn ? ctaBtn.querySelector('.pdp-cta-text') : null;
    const buyNowBtn = document.getElementById('pdp-buy-now-btn');

    if (isAvailable) {
      if (ctaBtn) ctaBtn.disabled = false;
      if (ctaText) {
        ctaText.innerHTML = `
          <span class="pdp-btn-label">ADD TO BAG</span>
          <span class="pdp-btn-dot">&bull;</span>
          <span class="pdp-btn-price">${formattedPrice}</span>
        `;
      }
      if (buyNowBtn) buyNowBtn.disabled = false;
    } else {
      if (ctaBtn) ctaBtn.disabled = true;
      if (ctaText) {
        ctaText.innerHTML = `<span class="pdp-btn-label">SOLD OUT</span>`;
      }
      if (buyNowBtn) buyNowBtn.disabled = true;
    }
  }

  function selectPdpVariantBox(button, variantId, formattedPrice, sizeTitle, isAvailable) {
    selectPdpSizeValue(button, sizeTitle, variantId, formattedPrice, isAvailable);
  }

  // Optimistic Cart Badge Increment (0ms Instant Feedback)
  function optimisticallyIncrementCartBadge(qty = 1) {
    const badgeSelectors = '#site-cart-count, #desktop-cart-count, #mobile-cart-count, .cart-count-badge, .header-cart-count, [data-cart-count]';
    document.querySelectorAll(badgeSelectors).forEach((b) => {
      const count = Math.max(0, (parseInt(b.textContent.trim(), 10) || 0) + qty);
      b.textContent = count;
      b.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  // Keep the form's hidden variant input in step with the selected variant.
  function syncPdpVariantInput(variantId) {
    const input = document.getElementById('pdp-variant-id');
    if (!input || !variantId) return;
    input.value = variantId;
    input.disabled = false;
  }

  function showPdpFormError(message) {
    const box = document.getElementById('pdp-form-error');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    box.classList.add('is-visible');
  }

  function clearPdpFormError() {
    const box = document.getElementById('pdp-form-error');
    if (!box) return;
    box.textContent = '';
    box.hidden = true;
    box.classList.remove('is-visible');
  }

  function announcePdp(message) {
    const region = document.getElementById('cart-live-region');
    if (region) region.textContent = message;
  }

  // 4. Add to cart — submits the real product form through the Cart AJAX API.
  async function submitPdpForm(event) {
    if (event) event.preventDefault();

    const form = document.getElementById('pdp-product-form');
    const ctaBtn = document.getElementById('pdp-add-to-bag-btn');
    if (!form || !ctaBtn || ctaBtn.disabled) return;

    clearPdpFormError();

    const formData = new FormData(form);
    formData.append('sections_url', window.location.pathname);

    const quantity = parseInt(formData.get('quantity'), 10) || 1;

    ctaBtn.classList.remove('is-added');
    ctaBtn.classList.add('is-loading');
    ctaBtn.disabled = true;
    optimisticallyIncrementCartBadge(quantity);

    try {
      const response = await fetch(window.themeRoutes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        optimisticallyIncrementCartBadge(-quantity);
        ctaBtn.classList.remove('is-loading');
        ctaBtn.disabled = false;
        const message = data.description || data.message || window.themeStrings.cartError;
        showPdpFormError(message);
        announcePdp(message);
        return;
      }

      const cartRes = await fetch(window.themeRoutes.cart + '.js');
      const updatedCart = await cartRes.json();

      document
        .querySelectorAll('#site-cart-count, #desktop-cart-count, #mobile-cart-count, .cart-count-badge, .header-cart-count, [data-cart-count]')
        .forEach((el) => {
          el.textContent = updatedCart.item_count;
          el.style.display = updatedCart.item_count > 0 ? 'inline-flex' : 'none';
        });

      if (typeof renderBottomCartBar === 'function') renderBottomCartBar(updatedCart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));

      announcePdp(window.themeStrings.cartAdded);

      ctaBtn.classList.remove('is-loading');
      ctaBtn.classList.add('is-added');
      setTimeout(() => {
        ctaBtn.classList.remove('is-added');
        ctaBtn.disabled = false;
      }, 2200);
    } catch (e) {
      optimisticallyIncrementCartBadge(-quantity);
      ctaBtn.classList.remove('is-loading');
      ctaBtn.disabled = false;
      showPdpFormError(window.themeStrings.cartError);
      announcePdp(window.themeStrings.cartError);
    }
  }

  // 5. Quantity stepper, gift-card fields and form wiring.
  function initPdpForm() {
    const form = document.getElementById('pdp-product-form');
    if (!form || form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    form.addEventListener('submit', submitPdpForm);
    syncPdpVariantInput(currentPdpVariantId);

    const qtyInput = document.getElementById('pdp-quantity');
    form.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const step = parseInt(qtyInput.step, 10) || 1;
        const min = parseInt(qtyInput.min, 10) || 1;
        const max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
        const delta = parseInt(btn.dataset.qtyChange, 10) * step;
        const next = Math.min(max, Math.max(min, (parseInt(qtyInput.value, 10) || min) + delta));
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const giftToggle = form.querySelector('[data-gift-card-toggle]');
    const giftFields = form.querySelector('[data-gift-card-fields]');
    const giftOffset = form.querySelector('[data-gift-card-offset]');
    if (giftOffset) giftOffset.value = new Date().getTimezoneOffset();
    if (giftToggle && giftFields) {
      giftToggle.addEventListener('change', () => {
        giftFields.hidden = !giftToggle.checked;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initPdpForm);
  document.addEventListener('shopify:section:load', initPdpForm);
  initPdpForm();
